<script lang="ts">
  import { Heading, Paragraph, Wrapper } from './components';
  import type { UseFormattedProps } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
</script>

<Wrapper style="background:var(--vlt-lp-background);">
  <section id={properties.anchor} class="section-excited-pen wf-section">
    <div class="div-famous-cry">
      <div class="div-desk-toy">
        <div class="div-space-mostly">
          <img
            src={properties.image}
            loading="lazy"
            alt=""
            class="img-universe-get"
          />
        </div>
        <div class="div-breath-father" />
        <div class="div-slide-care">
          <p class="p-helpful-bread">
            <Heading type={'h2'} css={'margin-bottom:50px;'}>
              <div class="a-hunt-living">
                {@html properties.heading}
              </div>
            </Heading>
          </p>
          <Paragraph>
            <p class="p-medicine-valley">
              {@html properties.text}
            </p>
          </Paragraph>

          <div class="div-upward-selection" />
        </div>
      </div>
    </div>
  </section>
</Wrapper>

<style>
  .div-upward-selection {
    padding: 0px;
    font-weight: 400;
    text-decoration: none;
  }

  .div-breath-father {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: 0px;
    padding: 0px;
    background-image: linear-gradient(90deg, #111827, transparent);
    font-weight: 400;
    text-decoration: none;
  }

  .img-universe-get {
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    font-weight: 400;
    text-decoration: none;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .section-excited-pen {
    background-color: var(--vlt-lp-background);
    font-weight: 400;
    text-decoration: none;
  }

  .div-famous-cry {
    max-width: 80rem;
    margin-right: auto;
    margin-left: auto;
    padding: 0 27px;
    font-weight: 400;
    text-decoration: none;
  }

  .div-space-mostly {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: 0px;
    padding: 0px;
    font-weight: 400;
    text-decoration: none;
  }

  .a-hunt-living {
    margin: 0px;
    padding: 0px;
    color: #f9fafb;
    font-weight: 400;
    text-decoration: none;
  }

  .div-slide-care {
    position: relative;
    max-width: 32rem;
    margin: 0px;
    padding: 3rem 4rem;
    font-weight: 400;
    text-decoration: none;
  }

  .p-helpful-bread {
    margin-top: 3rem;
    padding: 0px;
    color: #fff;
    font-size: 1.875rem;
    line-height: 2.25rem;
    font-weight: 700;
    text-decoration: none;
  }

  .p-medicine-valley {
    margin-top: 1rem;
    padding: 0px;
    color: #fff;
    font-size: 1rem;
    line-height: 1.75rem;
    font-weight: 400;
    text-decoration: none;
  }

  .div-desk-toy {
    position: relative;
    overflow: hidden;
    margin: 0px;
    padding: 0px;
    border-style: solid;
    border-width: 0;
    border-radius: 0.75rem;
    font-weight: 400;
    text-decoration: none;
  }

  @media screen and (min-width: 1280px) {
    .div-slide-care {
      max-width: 32rem;
      padding: 3rem 4rem;
    }

    .p-helpful-bread {
      font-size: 1.875rem;
      line-height: 2.25rem;
    }
  }

  @media screen and (min-width: 1440px) {
    .a-hunt-living {
      color: #f9fafb;
    }

    .div-slide-care {
      max-width: 32rem;
      padding: 3rem 4rem;
    }

    .p-helpful-bread {
      font-size: 1.875rem;
      line-height: 2.25rem;
    }
  }

  @media screen and (max-width: 991px) {
    .div-slide-care {
      max-width: 32rem;
      padding: 3rem 4rem;
    }

    .p-helpful-bread {
      font-size: 1.875rem;
      line-height: 2.25rem;
    }
  }

  @media screen and (max-width: 767px) {
    .section-excited-pen {
      padding: 20px 0;
    }

    .div-famous-cry {
      padding: 0 15px;
    }

    .div-slide-care {
      max-width: 32rem;
      padding: 3rem 4rem;
    }

    .p-helpful-bread {
      font-size: 1.875rem;
      line-height: 2.25rem;
    }
  }

  @media screen and (max-width: 479px) {
    .a-hunt-living {
      color: #f9fafb;
    }

    .div-slide-care {
      padding: 2rem;
    }

    .p-helpful-bread {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }
</style>
